import BordFlag from 'components/NudosComponents/BordFlag/BordFlag';
import BordUploaderButton from 'components/NudosComponents/BordUploaderButton/BordUploaderButton';
import { COUNTRY_CODES, TcountryCode } from 'components/NudosComponents/BordFlag/BordFlag.types';
import { IStorageBillingInvoices } from 'types/billing.types';
import './BillingInfo.scss';

interface IBillingInfoProps {
  billingInvoice?: IStorageBillingInvoices;
  isLoading: boolean;
}
const BillingInfo = ({ billingInvoice, isLoading }: IBillingInfoProps) => {
  const billingData = billingInvoice?.billedTo;
  const fileTitle = () => {
    switch (billingData?.countryCode) {
      case COUNTRY_CODES.mx:
        return 'Constancia de situación fiscal';
      case COUNTRY_CODES.co:
        return 'RUT';
      case COUNTRY_CODES.br:
        return 'Cadastro';
      default:
        return 'Documento fiscal de la empresa';
    }
  };

  const handleDownloadTaxSituationDocButtonClick = () => {
    if (!billingData?.taxSituationDocUrl) return;
    window.open(billingData?.taxSituationDocUrl, '_blank');
  };
  if (isLoading) return <div className="billingInfoSkeleton animationLoader" />;
  return (
    <>
      <div className="billingInfoTitle">Información de la facturación</div>
      <div className="billingInfo">
        <span className="billingInfoHeaderTitle">Información del cliente</span>
        <div className="internalDivider" />
        <div className="billingInfoBody">
          <div className="billingInfoBodyItem">
            <span className="billingInfoBodyItemTitle">País del documento</span>
            <div className="billingInfoBodyItemContent flagCountry">
              <BordFlag country={billingData?.countryCode as TcountryCode} variant="circle" customWidth="14px" />
              <span className="billingInfoBodyItemContentText">{billingData?.country}</span>
            </div>
          </div>
          {!!billingData?.document && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Documento de identificación fiscal</span>
              <span className="billingInfoBodyItemContent">{billingData?.document}</span>
            </div>
          )}
          <div className="billingInfoBodyItem">
            <span className="billingInfoBodyItemTitle">Razón social o denominación</span>
            <span className="billingInfoBodyItemContent">{billingData?.companyName}</span>
          </div>
          {!!billingData?.additionalBillingData && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Inscripción estatal</span>
              <span className="billingInfoBodyItemContent">{billingData?.additionalBillingData}</span>
            </div>
          )}
          {!!billingData?.colony && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Barrio o vecindario</span>
              <span className="billingInfoBodyItemContent">{billingData?.colony}</span>
            </div>
          )}
          {!!billingData?.fantasyName && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Nombre fantasia</span>
              <span className="billingInfoBodyItemContent">{billingData?.fantasyName}</span>
            </div>
          )}
          {!!billingData?.phone && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Número de teléfono</span>
              <span className="billingInfoBodyItemContent">
                +{billingData?.phoneCode} {billingData?.phone}
              </span>
            </div>
          )}
          {!!billingData?.address && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Dirección de facturación</span>
              <span className="billingInfoBodyItemContent">{billingData?.address}</span>
            </div>
          )}
          {!!billingData?.zipCode && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Código postal</span>
              <span className="billingInfoBodyItemContent">{billingData?.zipCode}</span>
            </div>
          )}
          {!!billingData?.city && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Ciudad</span>
              <span className="billingInfoBodyItemContent">{billingData?.city}</span>
            </div>
          )}
          {!!billingData?.state && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Estado/Provincia/Departamento</span>
              <span className="billingInfoBodyItemContent">{billingData?.state}</span>
            </div>
          )}
          {!!billingData?.email && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Correo de facturación</span>
              <span className="billingInfoBodyItemContent">{billingData?.email}</span>
            </div>
          )}
          {!!billingData?.taxUse && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Uso de la factura</span>
              <span className="billingInfoBodyItemContent">{billingData?.taxUse}</span>
            </div>
          )}
          {!!billingData?.taxSituation && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Regimen fiscal</span>
              <span className="billingInfoBodyItemContent">{billingData?.taxSituation}</span>
            </div>
          )}
          {!!billingData?.additionalReferences && (
            <div className="billingInfoBodyItem">
              <span className="billingInfoBodyItemTitle">Indicaciones</span>
              <span className="billingInfoBodyItemContent">{billingData?.additionalReferences}</span>
            </div>
          )}
        </div>
        {!!billingData?.taxSituationDocUrl && (
          <BordUploaderButton
            defaultFile={{
              documentName: fileTitle(),
              url: billingData?.taxSituationDocUrl || 'pending'
            }}
            customClassName="billingInfoDocContainer"
            customContainerClassName="billingInfoDoc"
            customFileNameClass="billingInfoDocFileName"
            isFilled
            iconsCustomWidth="12px"
            handleDownloadFile={handleDownloadTaxSituationDocButtonClick}
          />
        )}
      </div>
    </>
  );
};

export default BillingInfo;
